import { render, staticRenderFns } from "./AddSalary.vue?vue&type=template&id=28e8c867&scoped=true&"
import script from "./AddSalary.vue?vue&type=script&lang=js&"
export * from "./AddSalary.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28e8c867",
  null
  
)

export default component.exports